/// <summary>
/// Trạng thái
/// </summary>
export default {
  /// <summary>
  /// Bán mới
  /// </summary>
  IsBuyNew: 0,
  /// <summary>
  /// Nâng cấp
  /// </summary>
  IsUpgrade: 1,
  /// <summary>
  /// Gia hạn
  /// </summary>
  IsExtended: 2,
  /// <summary>
  ///  Miễn phí
  /// </summary>
  IsFree: 3,
  /// <summary>
  /// Dùng thử
  /// </summary>
  IsTrial: 4,
  /// <summary>
  /// Loại khác
  /// </summary>
  Different: 5,
  /// <summary>
  /// Thay đổi thông tin
  /// </summary>
  ChangeInfo: 6,
  /// <summary>
  ///  Mua thêm 
  /// </summary>
  BuyMore: 7,
  /// <summary>
  /// Vừa gia hạn vừa mua thêm
  /// </summary>
  ExtendedAndBuyMore: 8
};
